var map = {
	"./android-green-round-2.svg": 682,
	"./android-green.svg": 77,
	"./avatar.svg": 430,
	"./design.svg": 339,
	"./github.svg": 2,
	"./heart-outline.svg": 259,
	"./laptop.svg": 388,
	"./link.svg": 473,
	"./linkedin-3.svg": 220,
	"./mobile.svg": 191,
	"./moon.svg": 956,
	"./sun.svg": 35,
	"./tailwindcomponents.svg": 61,
	"./web.svg": 878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 498;